import axios from 'axios'
import omit from 'lodash/omit'

import config from '@/config/global'
import auth from '../interceptors/FpAuthenticationInterceptor'
import king from './king'

class Api {
  constructor () {
    let options = {}
    options.baseURL = config.API
    options.withCredentials = true
    this.xhr = axios.create(options)
    this.xhr.interceptors.request.use(auth.request[0], auth.request[1])
    this.xhr.interceptors.response.use(auth.response[0], auth.response[1])
  }

  getToken = async () => {
    const token = await this.king.getToken()
    return token
  }

  config () { return this.xhr.get('public/config') }
  get king () { return king.call(this) }

  packages () {
    let that = this
    return {
      async all () {
        const token = await that.getToken()

        return that.xhr.get('/v1', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
      },
      async put (consumer, type, id, pckg) {
        const token = await that.getToken()

        return that.xhr.put(`v1/packages/${consumer}/${type}/${id}`, omit(pckg, [
          'creator',
          'owned',
          'original',
          'acl'
        ]), {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
      }
    }
  }
  package (consumer, type, id) {
    let that = this
    return {
      version (name) {
        return {
          put (file, contentType) {
            let url = `v1/packages/${consumer}/${type}/${id}/${encodeURIComponent(name)}`
            return that.xhr.put(url, file, {
              headers: {
                'Content-type': contentType || file.type
              }
            })
          },
          delete () { return that.xhr.delete(`v1/packages/${consumer}/${type}/${id}/${encodeURIComponent(name)}`) }
        }
      }
    }
  }
}

export { Api }

export default {
  install (Vue) {
    Vue.api = Vue.prototype.$api = new Api()
  }
}
